import React from 'react';
import {
  MacroDirectoryCardStoryblok,
  RichtextStoryblok,
} from '../../../../types/storyblok';
import { Box } from '../../../../base/Box/Box';
import { AddOn } from './components/Addon';
import { Dropdown } from './components/Dropdown';
import { External } from './components/External';

const shouldRenderDropdown = (dropdownText: RichtextStoryblok) => {
  if (!dropdownText || !dropdownText.content) {
    return false;
  }

  return dropdownText.content.some(
    (element) => !!element.content && !!element.content.length
  );
};

export const MacroDirectoryCard = ({
  heading,
  stage,
  sector,
  link,
  colourScheme,
  stageDarkIcon,
  stageLightIcon,
  sectorDarkIcon,
  sectorLightIcon,
  dropdownText,
}: MacroDirectoryCardStoryblok) => {
  if (!heading) {
    return null;
  }

  return (
    <Box
      as="article"
      className="ff-divider border border-x-0 border-b-0 p-7"
      overlayOverBkg
    >
      <Box as="div" className="flex gap-8">
        <AddOn
          message={stage}
          colourScheme={colourScheme}
          darkIcon={stageDarkIcon}
          lightIcon={stageLightIcon}
        />
        <AddOn
          message={sector?.toString()}
          colourScheme={colourScheme}
          darkIcon={sectorDarkIcon}
          lightIcon={sectorLightIcon}
        />
      </Box>
      {link &&
        (shouldRenderDropdown(dropdownText) ? (
          <Dropdown
            text={dropdownText}
            link={link}
            heading={heading}
            colourScheme={colourScheme}
          />
        ) : (
          <External heading={heading} link={link} />
        ))}
    </Box>
  );
};

export default MacroDirectoryCard;
